import Pagination from "react-js-pagination";
import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

import routes from '../libs/routes';
import images from "../libs/images";
import * as API from "../libs/service";
import { useSelector } from "react-redux";
import { numFormat } from "../libs/utils";

export default function PaginationPayList(props) {
    const {
        paylists=[]
    } = props

    const dataList = paylists;

    const [page, setPage] = useState(1);
    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };  
    const lang = useSelector(state => state.langReducer.lang);
    const { mbData } = useSelector((s) => s.usersReducer);

    const itemsPerPage = 8;
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const Items = dataList.slice(indexOfFirstItem, indexOfLastItem);
    const [mainCard, setMainCard] = useState({});
    useEffect(() => {
        cardData();
    }, []);
    const cardData = async() => {
        const result = await API.xsollaApis("user/XsolaApiCardlist", {idx: mbData?.idx});
        //setMainCard(result?.result);
        setMainCard(result?.result);
        //console.log(result?.result);
    }
    return (
        <div className="PaginationContent">
            <div className="my_coupon_list_box pay_list">
                <div className="list_title">
                    <p>{lang === 0 ? '결제 상품' : 'Purchased Item'}</p>
                    <p>{lang === 0 ? '라이선스' : 'License'}</p>
                    <p>{lang === 0 ? '결제일' : 'Payment Date'}</p>
                    <p>{lang === 0 ? '결제 카드' : 'Payment Card'}</p>
                    <p>{lang === 0 ? '결제금액' : 'Payment Amount'}</p>
                </div>

                {dataList.length === 0 ?
                    <p className="not_coupon">{lang === 0 ? '결제 내역이 없습니다.' : 'No payment history available.'}</p>
                    :
                    <>
                        {Items.map((x, i) => (
                            <div key={i} className={`my_coupon_info`}>
                                <p className="code">UModeler X {x?.plan}</p>
                                <p className="code">{x?.licenseCode}</p>
                                <p>{moment(x?.pay_dt).format('YYYY-MM-DD HH:mm')}</p>
                                <p>{x?.cardName}</p>
                                <p>{x?.showWon === 'USD' ? 'USD' : ''} {numFormat(x?.pay_price)} {x?.showWon === 'USD' ? '' : lang === 0 ? '원' : 'KRW'}</p>
                            </div>
                        ))}
                    </>
                }                
                
            </div>

            <Pagination
                className="my-pagination"
                // 현재 보고있는 페이지
                activePage={page}
                // 한페이지에 출력할 아이템수
                itemsCountPerPage={itemsPerPage}
                // 총 아이템수
                totalItemsCount={dataList.length || 1}
                // 표시할 페이지수
                pageRangeDisplayed={10}
                // 함수
                onChange={handlePageChange}
                nextPageText={<img src={require("../assets/icon/page_right.svg").default}/>}
                prevPageText={<img src={require("../assets/icon/page_left.svg").default}/>}
                firstPageText={<img src={require("../assets/icon/page_left_set.svg").default}/>}
                lastPageText={<img src={require("../assets/icon/page_right_set.svg").default}/>}
            ></Pagination>
        </div>
    )
}